import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

interface ContactListItemLinkProps {
  target?: string;
  rel?: string;
  href: string;
  content: string;
}

export interface ContactListItemProps {
  icon: IconProp;
  fixedWidth?: boolean;
  link?: ContactListItemLinkProps;
  text?: string;
  onClick?: () => void;
}

export const ContactListItem = ({
  icon,
  fixedWidth = true,
  link,
  text,
  onClick,
}: ContactListItemProps) => {
  return (
    <li className={"contact-list-item"}>
      <FontAwesomeIcon
        className={"text-primary"}
        fixedWidth={fixedWidth}
        icon={icon}
      />
      {link ? (
        <a
          href={link.href}
          className={"mx-2"}
          target={link.target || "_blank"}
          rel={link.rel || "noopener noreferrer"}
          onClick={() => {
            if (onClick) {
              onClick();
            }
          }}
        >
          {link.content}
        </a>
      ) : null}
      {text ? <span className={"mx-2"}>{text}</span> : null}
    </li>
  );
};
